module.exports = __webpack_public_path__ + "assets/2c443cbf5b25bb276e00163d232132c5.svg";